import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsConditions = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Banner */}
      <div className="bg-gradient-to-br from-[#1E1B4B] to-[#312E81] pt-28 pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#A78BFA] hover:text-white mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-[#6366F1]/20 flex items-center justify-center">
              <FileText className="w-5 h-5 text-[#A78BFA]" />
            </div>
            <span className="pill-badge bg-[#6366F1]/20 text-[#A78BFA] text-xs">Legal</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display',serif" }}>Terms & Conditions</h1>
          <p className="text-sm text-white/50 font-normal">Last updated: February 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
        <div className="space-y-10">
          <div>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              Welcome to Trademark Symbol Font. By accessing and using our website and services, you agree to be bound by these Terms and Conditions. Please read them carefully before engaging our services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Services</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              Trademark Symbol Font provides trademark registration, copyright registration, business formation, trademark search, brand monitoring, and related intellectual property services through licensed professionals. Our services are subject to availability and applicable laws.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Fees & Payment</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed mb-3">
              Our service fees are separate from government filing fees charged by the USPTO or other agencies. All fees are disclosed upfront before engagement. Key terms include:
            </p>
            <ul className="space-y-2 ml-1">
              {['Service fees are non-refundable once filing has commenced', 'Government fees are paid directly to the relevant agency', 'All pricing is in US Dollars', 'Payment is required before filing begins'].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-base font-normal text-[#4B5563]">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#6366F1] mt-2.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Limitation of Liability</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              While we strive for the highest success rates, we cannot guarantee the approval of any trademark or copyright application by the USPTO or US Copyright Office. Government agencies make final registration decisions independently. Our liability is limited to the service fees paid.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Intellectual Property</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              All content on this website, including text, graphics, logos, and software, is the property of Trademark Symbol Font and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our written consent.
            </p>
          </div>

          <div className="bg-[#F5F3FF] border border-[#EDE9FE] rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-[#1E1B4B] mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Questions</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">
              Questions about these Terms should be directed to{' '}
              <a href="mailto:info@trademarksymbolfont.com" className="text-[#6366F1] hover:text-[#4F46E5] font-medium">info@trademarksymbolfont.com</a>{' '}
              or our office at 3031 Tisch Way 110 PW, San Jose, CA 95128.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
